/** Easter egg developer comments displayed as badges next to section titles when the DEV_COMMENTS debug toggle is active. Each entry contains a short quip, a longer reveal message, and an emoji icon for personality. */
export const devComments = {
  /** Dev comment for the Hero section -- pokes fun at framerate expectations */
  hero: {
    text: "30fps = cinematic mode",
    reveal: "lost 20 frames. called it a feature. shipped it.",
    icon: "\uD83D\uDD27",
  },
  /** Dev comment for the About section -- jokes about dependencies being mistaken for skills */
  about: {
    text: "npm list does not match resume",
    reveal: "47 dependencies, 0 actual skills. story of my life.",
    icon: "\uD83D\uDCCB",
  },
  /** Dev comment for the Experience section -- humor about the effort behind simple changes */
  experience: {
    text: "3 weekends for 2 lines of code",
    reveal: "damping 18 to 20. plane no longer drunk. shipped without review.",
    icon: "\u2708\uFE0F",
  },
  /** Dev comment for the Projects section -- riff on the catapult project having zero code commits */
  projects: {
    text: "catapult: 0 commits, 47 splinters",
    reveal:
      "optimized mass distribution with a hammer. judges were impressed. or scared.",
    icon: "\uD83C\uDFAF",
  },
  /** Dev comment for the Achievements section -- joking about manual timeline curation */
  achievements: {
    text: "timeline sorted by hand",
    reveal: "2021 was two commits and a nap. don't auto-sort.",
    icon: "\uD83C\uDFC6",
  },
  /** Dev comment for the Education section -- jab at disorganized certificate files */
  education: {
    text: "certificates in drive. probably.",
    reveal:
      "scan_2018.jpg to untitled (47). even drive search gave up.",
    icon: "\uD83D\uDCDC",
  },
  /** Dev comment for the Recommendations section -- meta-humor about the carousel being unwanted */
  recommendations: {
    text: "carousel autoplays. who asked?",
    reveal:
      'added for engagement. one user said "oh cool" and left forever.',
    icon: "\uD83D\uDCAC",
  },
  /** Dev comment for the Resume section -- joke about the PDF surviving chaos */
  resume: {
    text: "resume pdf might vanish tonight",
    reveal:
      "survived 3 migrations and a laptop drop. google's patience? less so.",
    icon: "\uD83D\uDCC4",
  },
  /** Dev comment for the FAQ section -- riff on googling yourself and answering your own questions */
  faq: {
    text: "seo? i barely know her",
    reveal:
      "10 questions. 0 people asked. 100% schema.org compliance.",
    icon: "\uD83E\uDD14",
  },
  /** Dev comment for the Side Projects section -- jab at README status vs. reality */
  sideProjects: {
    text: "7 repos, 3 up-to-date changelogs",
    reveal: "the readme says 'in progress'. it has said that since March.",
    icon: "\uD83D\uDEE0\uFE0F",
  },
  /** Dev comment for the Archive section -- nostalgia about pre-git-discipline code */
  archive: {
    text: "isangeet.apk still installs",
    reveal: "2021 me did not believe in commit messages. 2021 me was wrong.",
    icon: "\uD83D\uDCFC",
  },
};
